export const API = {
	async postReq(
		endpoint: string,
		payload: {},
		authorization?: string
	): Promise<{} | undefined> {
		let options = {
			contentType: "application/json",
			data: JSON.stringify(payload),
			headers: {},
			type: "POST",
			url: endpoint
		};

		if (authorization) {
			options = { ...options, headers: { Authorization: authorization } };
		}

		const promise = $.ajax(options);

		const result = await Promise.resolve(promise);

		return result;
	}
};
